import { filter } from "utils/lodash";
import config from "config";

const omitSingle = (key, { [key]: _, ...obj }) => obj;

export const unstyle = props => omitSingle("styles", props);

export const splitPath = url =>
  filter(url.trim().split("/"), x => x && x.length > 0);

export const getQueryVariable = (variable, search) => {
  const queryParams = search.split("?").filter(item => item.length > 0);
  const queryParamsList =
    queryParams.length > 0
      ? queryParams[0].split("&").filter(item => item.length > 0)
      : [];

  for (let i = 0; i < queryParamsList.length; i += 1) {
    const pair = queryParamsList[i].split("=");

    if (decodeURIComponent(pair[0]) === variable) {
      if (pair[1] === "undefined") {
        return undefined;
      }
      return decodeURIComponent(pair[1]);
    }
  }

  return undefined;
};

export const thereAreParametersInUrl = url => {
  if (!url) return null;
  const regex = new RegExp("[?&]");
  const results = regex.exec(url);
  return !!results;
};

export const getDomainWebchat = () => {
  const { webchat } = config;
  if (webchat) {
    const {
      isDev,
      isStaging,
      isPreproduction,
      isProduction,
      domainDev,
      domainStaging,
      domainPreproduction,
      domainProduction,
    } = webchat;
    if (isDev) {
      return domainDev;
    }
    if (isStaging) {
      return domainStaging;
    }
    if (isPreproduction) {
      return domainPreproduction;
    }
    if (isProduction) {
      return domainProduction;
    }
  }
  return "";
};

export const isIE = () =>
  !!navigator.userAgent.match(/Trident/g) ||
  !!navigator.userAgent.match(/MSIE/g);

export const encodeString = data => btoa(encodeURI(data));
export const decodeString = data => decodeURI(atob(data));
export const getDomainWebchatInNewChannel = () => {
  const {
    azure: { channels },
  } = config;
  return channels;
};

export const getCvars = cvars => {
  if (cvars) {
    const objectCvars = {};
    const cvarsSplited = cvars.split("!*^|");
    cvarsSplited.forEach(cvar => {
      const cvarSplited = cvar.split("^*");
      const key = cvarSplited[0];
      const value = cvarSplited[1];
      objectCvars[key] = value;
    });
    return objectCvars;
  }
  return undefined;
};

export const isFromWidgetScript = search => search.includes("from_script=1");

export default {
  unstyle,
  splitPath,
  getQueryVariable,
};
